import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import DropDownList from '../DropDownList'
import FieldGroup from '../FieldGroup'

const months = [
  { value: 0, data: 'January' },
  { value: 1, data: 'February' },
  { value: 2, data: 'March' },
  { value: 3, data: 'April' },
  { value: 4, data: 'May' },
  { value: 5, data: 'June' },
  { value: 6, data: 'July' },
  { value: 7, data: 'August' },
  { value: 8, data: 'September' },
  { value: 9, data: 'October' },
  { value: 10, data: 'November' },
  { value: 11, data: 'December' }
]

const getYearValidation = (value) => {
  const year = parseInt(value)
  const currentYear = new Date().getFullYear()

  // Callers (validateStartEndYear and the education / work-experience reducers' isFormValid)
  // gate the Save button on the `valid` flag, so every result MUST include it. Without it
  // `valid` was undefined and a perfectly valid year disabled Save.
  if (!value) {
    return { isInvalid: true, message: 'Please enter a year', valid: false }
  }

  if (isNaN(year)) {
    return { isInvalid: true, message: 'Please enter only numeric values', valid: false }
  }

  if (value.length !== 4) {
    return { isInvalid: true, message: 'Please enter a valid 4-digit year', valid: false }
  }

  if (year > currentYear) {
    return { isInvalid: true, message: 'Year cannot be in the future', valid: false }
  }

  if (year < currentYear - 50) {
    return { isInvalid: true, message: 'Year cannot be older than 50 years', valid: false }
  }

  return { isInvalid: false, message: '', valid: true }
}

const YearMonthPicker = ({
  handleChange,
  label,
  disabled,
  month,
  year,
  handleMonth,
  handleYear,
  yearisInvalid,
  monthisInvalid
}) => {

  const [touched, setTouched] = React.useState(false)

  const handleYearChange = (event) => {
    const value = event.target.value

    // allow empty (incomplete - not yet valid, so Save stays gated until a year is entered)
    if (value === '') {
      handleYear({ isInvalid: false, message: '', valid: false }, '')
      return
    }

    // allow only numbers
    if (!/^\d*$/.test(value)) return

    // max 4 digits
    if (value.length > 4) return

    const validation = getYearValidation(value)

    handleYear( validation,value)

    if (value.length === 4) {
      handleChange()
    }
  }

  const safeYear =
    year && !isNaN(parseInt(year)) ? parseInt(year) : ''

  const safeMonth =
    typeof month === 'number' ? month : 11

  return (
    <Row>
      {/* MONTH */}
      <Col sm={6} md={6} lg={6} className="d-none d-sm-block">
        <DropDownList
          label={label + ' month'}
          listData={months}
          value={safeMonth}
          disabled={disabled}
          required
          handleChange={(value) => {
            handleMonth(parseInt(value))
            handleChange()
          }}
          message={monthisInvalid?.message || ''}
          isInvalid={monthisInvalid?.isInvalid}
        />
      </Col>

      {/* YEAR */}
      <Col sm={6} md={6} lg={6} className="d-none d-sm-block">
        <FieldGroup
          type="number"
          required
          disabled={disabled}
          value={safeYear}
          placeholder="YYYY"
          label={label + ' year'}
          isInvalid={yearisInvalid?.isInvalid}
          message={yearisInvalid?.message || ''}
          onFocus={() => setTouched(true)}
          onChange={handleYearChange}
        />
      </Col>
    </Row>
  )
}

YearMonthPicker.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  month: PropTypes.number,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleMonth: PropTypes.func.isRequired,
  handleYear: PropTypes.func.isRequired,
  yearisInvalid: PropTypes.shape({
    isInvalid: PropTypes.bool,
    message: PropTypes.string
  }),
  monthisInvalid: PropTypes.shape({
    isInvalid: PropTypes.bool,
    message: PropTypes.string
  })
}

export default YearMonthPicker